import { render, staticRenderFns } from "./alertDialogTemplate.vue?vue&type=template&id=115f17f2&scoped=true&"
import script from "./alertDialogTemplate.vue?vue&type=script&lang=js&"
export * from "./alertDialogTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115f17f2",
  null
  
)

export default component.exports